import { jsxs, jsx } from "react/jsx-runtime";
import { Logo } from "@seek/logo";
import { useMelwaysInfo } from "@seek/melways-react";
import { Link, HiddenVisually, Box } from "braid-design-system";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { useApacCandidateHeaderContext } from "../../ApacCandidateHeader.mjs";
import { logo, responsiveLogoSizing } from "./Logo.css.mjs";
const HeaderLogo = ({
  isInvert = false,
  linkContext,
  seoText,
  href
}) => {
  const { injectLinkContextToData } = useLink();
  const { isMenuOpen, setIsMenuOpen } = useApacCandidateHeaderContext();
  const variant = isInvert ? "inverted" : "standard";
  const { brand } = useMelwaysInfo();
  return /* @__PURE__ */ jsxs(
    Link,
    {
      href,
      className: [logo, responsiveLogoSizing],
      data: injectLinkContextToData(linkContext, {
        automation: linkContext.source
      }),
      onClick: () => isMenuOpen && setIsMenuOpen(false),
      children: [
        seoText && /* @__PURE__ */ jsx(HiddenVisually, { data: { automation: seoText.toLocaleLowerCase() }, children: seoText }),
        /* @__PURE__ */ jsx(
          Box,
          {
            display: "block",
            component: "span",
            className: responsiveLogoSizing,
            children: /* @__PURE__ */ jsx(Logo, { variant, brand, size: "fill" })
          }
        )
      ]
    }
  );
};
export {
  HeaderLogo
};
